import {
	slideDown, slideUp, scrollToEl, headerOffsetHeight,
} from '../../../js/theme/helpers';

export class Accordion {
	// Default state for the accordion.
	isOpen = false;

	// Speed of opening/closing accordion in milliseconds.
	speed = 300;

	constructor({ control, content, group }) {
		if (control && content) {
			// Assign control, content, and group to Accordion instance
			this.control = control;
			this.content = content;
			this.group = group;

			// Attach an event listener to the control element when an instance of the Accordion class is created.
			// The listener listens for a 'click' event and calls the `handleControlClick` method.
			this.control.addEventListener('click', this.handleControlClick);
		}
	}

	open = () => {
		let delay = 0;
		if (this.hasOpenSiblings()) {
			// Delay before opening if other accordions in group are open.
			delay = this.speed;
			// Close any other open accordion sections in the same group.
			this.closeOpenSiblings();
		}

		// Wait for any open siblings to close before opening this accordion section.
		setTimeout(() => {
			// Update Accordion attributes.
			this.control.setAttribute('aria-expanded', 'true');
			slideDown(this.content, `${this.speed}ms`);
			this.isOpen = true;

			// Scroll to the control element when it's opened.
			scrollToEl(this.control, headerOffsetHeight());
		}, delay);
	}

	close = () => {
		// Update Accordion attributes.
		this.control.setAttribute('aria-expanded', 'false');
		slideUp(this.content, `${this.speed}ms`);
		this.isOpen = false;
	}

	hasOpenSiblings = () => {
		let hasOpenSiblings = false;
		const { accordions } = this.group;
		if (accordions.length) {
			for (let i = 0; i < accordions.length; i++) {
				if (accordions[i] !== this && accordions[i].isOpen) {
					hasOpenSiblings = true;
					break;
				}
			}
		}

		return hasOpenSiblings;
	}

	closeOpenSiblings = () => {
		const { accordions } = this.group;
		if (accordions.length) {
			accordions.forEach((accordion) => {
				if (accordion !== this) {
					accordion.close();
				}
			});
		}
	}

	handleControlClick = () => {
		if (this.isOpen) {
			this.close();
		} else {
			this.open();
		}
	}
}
